import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Select, SelectProps } from 'antd';

import { PersonalIdentifierType } from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

import { pidTypeList } from './SelectPidTypesV2';

type SelectPidTypeProps = SelectProps & {
  types?: PersonalIdentifierType[];
};

export const SelectPidType: FC<SelectPidTypeProps> = ({ placeholder, ...props }) => {
  const { t } = useTranslation('entities/personalIdentifiers', { keyPrefix: 'types' });

  const options = useMemo(() => {
    const filtered = props.types
      ? pidTypeList.filter((category) => props.types!.includes(category))
      : pidTypeList;

    return filtered.map((category) => ({
      value: category,
      label: t(personalIdentifiersI18nMap[category]),
    }));
  }, []);

  return <Select placeholder={placeholder ?? 'Select Type'} options={options} {...props} />;
};

export const personalIdentifiersI18nMap = {
  [PersonalIdentifierType.CITIZENSHIP_CERTIFICATE]: 'citizenshipCertificate',
  [PersonalIdentifierType.DRIVER_LICENSE]: 'driverLicense',
  [PersonalIdentifierType.PASSPORT]: 'passport',
  [PersonalIdentifierType.BIRTH_CERTIFICATE]: 'birthCertificate',
  [PersonalIdentifierType.EDUCATION]: 'education',
  [PersonalIdentifierType.FREE_BLOCK]: 'freeBlock',
  [PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE]: 'internationalDriverLicense',
  [PersonalIdentifierType.MEDICAL_ID]: 'medicalId',
  [PersonalIdentifierType.MILITARY_ID]: 'militaryId',
  [PersonalIdentifierType.NATIONAL_ID]: 'nationalId',
  [PersonalIdentifierType.RESIDENCE_PERMIT]: 'residencePermit',
  [PersonalIdentifierType.SOCIAL_SECURITY]: 'socialSecurity',
  [PersonalIdentifierType.SUBSTANCE]: 'substance',
  [PersonalIdentifierType.TAX_ID]: 'taxId',
};
